import { useForm, SubmitHandler } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
 import React, { useEffect } from "react";
import * as Yup from "yup"; 
import { cancelBooking, } from "../../../core/data/redux/action";
 import { yupResolver } from "@hookform/resolvers/yup";
 import { AppDispatch, RootState } from "../../../core/data/redux/store";
 
 

const CancelBooking = ({ booking }: { booking: any }) => {
  const dispatch = useDispatch<AppDispatch>();

  type FormValues = {
    reason: string;
  };

  const schema = Yup.object().shape({
    reason: Yup.string().required('Reason is required'),
  });

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitted },

    reset,
  } = useForm<FormValues>({
    resolver: yupResolver(schema),
    defaultValues: {
      reason: '',
    },
  });


  const { bookingCancelSuccess, bookingCancelLoading } = useSelector(
    (state: RootState) => ({
       bookingCancelSuccess: state.booking.bookingCancelSuccess,
       bookingCancelLoading: state.booking.bookingCancelLoading,
    })
  );
   


  const onSubmit: SubmitHandler<FormValues> = (data) => {
    dispatch(
      cancelBooking({
        status_id: '3',
        booking_id: booking.id?.toString(),
        cancel_reason: data.reason,
      })
    ); 
  
        reset();
    };

  useEffect(() => {
    if (bookingCancelSuccess) {
      reset();
    }
  }, [bookingCancelSuccess]);

  return (
    <>
      <div
        className="modal new-modal fade  "
        id="cancel_booking"
        data-keyboard="false"
        data-backdrop="static"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Cancel Booking</h4>
              <button
                type="button"
                className="btn close-btn"
                data-bs-dismiss="modal"
              >
                <span>×</span>
              </button>
            </div>
            <div className="modal-body">
              <p> Are you sure, Do you want to Cancel the Booking?</p>

              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="col-md-12">
                  <div className="input-block">
                    <label>
                      Reason <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className={`form-control mb-0 ${isSubmitted && errors.reason ? 'is-invalid' : ''}`}
                      placeholder="Enter Reason"
                      {...register('reason')}
                    />
                  </div>
                </div>
                <div className="col-md-12 text-end">
                  {!bookingCancelLoading && (
                    <>
                      <button
                        type="submit"
                        className="btn btn-primary  btn-size my-1 py-1"
                      >
                        Yes
                      </button>

                      <button className="btn close-btn" data-bs-dismiss="modal">
                        {' '}
                        NO
                      </button>
                    </>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Cancel Reason Modal */}
    </>
  );
};

export default CancelBooking;
